/**
 * CurrencyContext — Provides the org's display currency to the component tree.
 *
 * App.js owns the user state (fetched from /auth/me). It wraps the app with
 * <CurrencyProvider currency={user?.currency}> so that useCurrency() can read
 * the current currency without needing AuthProvider in the tree.
 */
import { createContext } from 'react';

const CurrencyContext = createContext('USD');

export default CurrencyContext;
